import React, { useState, useEffect } from 'react';
import Button from '../common/Button';
import Modal from '../common/Modal';

// Mutăm FormField în afara componentei pentru a evita re-crearea la fiecare render
const FormField = ({ label, field, type = 'text', required = false, formData, errors, onInputChange, ...props }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      type={type}
      value={formData[field]}
      onChange={(e) => onInputChange(field, e.target.value)}
      className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors[field] ? 'border-red-300' : 'border-gray-300'
        }`}
      {...props}
    />
    {errors[field] && (
      <p className="mt-1 text-sm text-red-600">{errors[field]}</p>
    )}
  </div>
);

const ClientForm = ({
  client = null,
  isOpen,
  onClose,
  onSubmit,
  loading = false
}) => {
  const [formData, setFormData] = useState({
    name: '',
    fiscalCode: '',
    address: '',
    locality: '',
    county: '',
    country: 'România',
    email: '',
    phone: '',
    iban: '',
    bank: '',
    representativeName: '',
    representativeFirstName: '',
    representativePosition: '',
    representativeEmail: '',
    representativePhone: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (client) {
      setFormData({
        name: client.name || '',
        fiscalCode: client.fiscalCode || '',
        address: client.address || '',
        locality: client.locality || '',
        county: client.county || '',
        country: client.country || 'România',
        email: client.email || '',
        phone: client.phone || '',
        iban: client.iban || '',
        bank: client.bank || '',
        representativeName: client.representativeName || '',
        representativeFirstName: client.representativeFirstName || '',
        representativePosition: client.representativePosition || '',
        representativeEmail: client.representativeEmail || '',
        representativePhone: client.representativePhone || ''
      });
    } else {
      // Reset form for new client
      setFormData({
        name: '',
        fiscalCode: '',
        address: '',
        locality: '',
        county: '',
        country: 'România',
        email: '',
        phone: '',
        iban: '',
        bank: '',
        representativeName: '',
        representativeFirstName: '',
        representativePosition: '',
        representativeEmail: '',
        representativePhone: ''

      });
    }
    setErrors({});
  }, [client, isOpen]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Numele firmei este obligatoriu';
    }

    if (!formData.fiscalCode.trim()) {
      newErrors.fiscalCode = 'Codul fiscal este obligatoriu';
    } else if (!/^(RO)?[0-9]{2,10}$/.test(formData.fiscalCode.replace(/\s/g, ''))) {
      newErrors.fiscalCode = 'Format cod fiscal invalid';
    }

    // if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //   newErrors.email = 'Format email invalid';
    // }

    // if (formData.representativeEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.representativeEmail)) {
    //   newErrors.representativeEmail = 'Format email reprezentant invalid';
    // }

    // if (formData.iban && !/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$/.test(formData.iban.replace(/\s/g, ''))) {
    //   newErrors.iban = 'Format IBAN invalid';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      
      onSubmit(formData);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: undefined
      }));
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={client ? 'Editează Client' : 'Client Nou'}
      size="lg"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Informații firmă */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField
            label="Nume Firmă"
            field="name"
            required
            placeholder="ex: Exemplu SRL"
            formData={formData}
            errors={errors}
            onInputChange={handleInputChange}
          />
          <FormField
            label="Cod Fiscal"
            field="fiscalCode"
            required
            placeholder="ex: RO12345678"
            formData={formData}
            errors={errors}
            onInputChange={handleInputChange}
          />
        </div>

        <FormField
          label="Adresă"
          field="address"
          placeholder="Strada, numărul, etc."
          formData={formData}
          errors={errors}
          onInputChange={handleInputChange}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <FormField
            label="Localitate"
            field="locality"
            placeholder="București"
            formData={formData}
            errors={errors}
            onInputChange={handleInputChange}
          />
          <FormField
            label="Județ"
            field="county"
            placeholder="București"
            formData={formData}
            errors={errors}
            onInputChange={handleInputChange}
          />
          <FormField
            label="Țară"
            field="country"
            placeholder="România"
            formData={formData}
            errors={errors}
            onInputChange={handleInputChange}
          />
        </div>

        {/* Informații bancare */}
        <div className="border-t pt-4">
          <h4 className="text-md font-medium text-gray-800 mb-3">Informații Bancare</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField
              label="Email"
              field="email"
              type="email"
              placeholder="contact@exemplu.ro"
              formData={formData}
              errors={errors}
              onInputChange={handleInputChange}
            />
            <FormField
              label="Telefon"
              field="phone"
              placeholder="0712345678"
              formData={formData}
              errors={errors}
              onInputChange={handleInputChange}
            />
            <FormField
              label="IBAN"
              field="iban"
              placeholder="RO49AAAA1B31007593840000"
              formData={formData}
              errors={errors}
              onInputChange={handleInputChange}
            />
          </div>
          <FormField
            label="Bancă"
            field="bank"
            placeholder="Banca Comercială Română"
            formData={formData}
            errors={errors}
            onInputChange={handleInputChange}
          />
        </div>

        {/* Informații reprezentant */}
        <div className="border-t pt-4">
          <h4 className="text-md font-medium text-gray-800 mb-3">Reprezentant</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField
              label="Nume"
              field="representativeName"
              placeholder="Popescu"
              formData={formData}
              errors={errors}
              onInputChange={handleInputChange}
            />
            <FormField
              label="Prenume"
              field="representativeFirstName"
              placeholder="Ion"
              formData={formData}
              errors={errors}
              onInputChange={handleInputChange}
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField
              label="Funcție"
              field="representativePosition"
              placeholder="Director General"
              formData={formData}
              errors={errors}
              onInputChange={handleInputChange}
            />
            <FormField
              label="Email Reprezentant"
              field="representativeEmail"
              type="email"
              placeholder="ion.popescu@exemplu.ro"
              formData={formData}
              errors={errors}
              onInputChange={handleInputChange}
            />
            <FormField
              label="Telefon Reprezentant"
              field="representativePhone"
              placeholder="0712345678"
              formData={formData}
              errors={errors}
              onInputChange={handleInputChange}
            />
          </div>
        </div>

        {/* Actions */}
        <div className="flex justify-end space-x-3 pt-6 border-t">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={loading}
          >
            Anulează
          </Button>
          <Button
            type="submit"
            loading={loading}
            disabled={loading}
          >
            {client ? 'Actualizează' : 'Creează'} Client
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ClientForm;